<ul class="p-0">
    <ng-container *ngFor="let item of items">
        <li class="menu-item" *ngIf="!item.hidden">
            <on-menu-item [item]="item"></on-menu-item>
        </li>
    </ng-container>
</ul>
